import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import {
  AppBar,
  Box,
  Badge,
  Button,
  Divider,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Menu,
  MenuItem,
  Toolbar,
  Tooltip,
  CircularProgress,
  Avatar
} from "@mui/material";
import { NOTIFICATIONS } from "../data/APIs";

import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";
import MenuIcon from "@mui/icons-material/Menu";
import format from "../utils/ISOToReadable";
import notificationSfx from "../assets/notificationsfx.wav";
import playSoundEffect from "../utils/playSoundEffect";
import pages from "../data/pages";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import useRequest from "../hooks/useRequest";
import { PlayArrow } from "@mui/icons-material";
import PlaySoundEffect from "../utils/playSoundEffect";
// import FileViewer from 'react-file-viewer';
const NotificationItem = ({ onClick, content, time, unread = false ,  natificationimage}) => {

  return (
    <ListItemButton
      onClick={onClick}
      sx={{ bgcolor: unread ? "rgba(0, 0, 0, 0.04)" : "initial" }}
    >
      <Avatar src={natificationimage}/>
      <ListItemText primary={content}  secondary={time}/>
    </ListItemButton>
  );
};

const Topbar = ({
  showBurger,
  onBurgerClick,
  onClear,
  notifications,
  isNotificationPending,
  loading,
  onNotificationsOpen,
  notification
}) => {
  //----states----
  const [notificationsState, setNotificationsState] = useState([]);
  const unreadNotifCache = useRef(0);
  const [unreadNotif, setUnreadNotif] = useState(0);
  const [readNotif, setReadNotif] = useState(0);
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  //store

  const notifictionsStore = useSelector((state) => state.notifications.value);
  // const notificationfromback=useSelector((state)=>state.NotificationBack.value)

  //----effects----

  // console.log(notifictions)
  useEffect(() => {
    setUnreadNotif(() => Math.minimumZero(notifictionsStore?.results?.length)+ Math.minimumZero(0))
    dispatch({type:"unread/set",payload:Math.minimumZero(notifictionsStore?.results?.length)+ Math.minimumZero(0)})
    //  playSoundEffect(); 
    // return ()=>notifications={}
  },[notifictionsStore]);

  useEffect(() => {
 
    if (!open)return
    // onNotificationsOpen();
     
    setReadNotif(notifictionsStore?.results?.length);
    dispatch({type:"unread/set",payload:0})
    setUnreadNotif(() => {
   
      unreadNotifCache.current = unreadNotif;
      return 0;
    });
    
  }, [open]);

  //----functions----
  const handleOpenMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseMenu = () => {
    unreadNotifCache.current = 0;
    setAnchorEl(null);
  };
 const [resetNotificationsGetRequest,resetNotificationsGetResponce] = useRequest({
   path: NOTIFICATIONS+"delete_all/",
   method: "delete",
 });
  const dispatch = useDispatch();
  const handleClear = () => {
   
    unreadNotifCache.current = 0;
    setUnreadNotif(0);
    setReadNotif(0);
    resetNotificationsGetRequest({
      
       onSuccess: (res) => {
        console.log(res)
         dispatch({
           type: "notifications/reset",
         });
       },
     });


  };

  //===Start======= Notification Redirects Logic ============
  const navigate = useNavigate();

  // Ghange lang
  const lang = useSelector((state) => state.lang.value.lang);

  ////////////////////
  
  const getPath = (name, isChild = false) => {
    switch (isChild) {
      case false:
        return pages.find((page) => page?.name[lang] === name)?.path;
      case true:
        const parent = pages.find(
          (page) =>
            page?.subtabs?.filter((subtab) => subtab?.name === name).length > 0
        );
        return (
          parent.path +
          parent.subtabs?.find((subtab) => subtab?.name === name)?.path
        );
    }
  };

  const typesAndPaths = {
    project: getPath("عرض المشاريع", true),
    unit: getPath("عرض الوحدات", true),
    followup: getPath("جميع العملاء", true),
    other: "",
  };

  //===End======= Notification Redirects Logic ============

  return (
    <AppBar
      position="static"
      sx={{
        boxShadow: "0px 3px 10px -1px rgb(35 57 117)",
        zIndex: 1,
      }}
      
    >
      <Toolbar>
        {showBurger && (
          <IconButton sx={{ color: "white" }} onClick={() => onBurgerClick()}>
            <MenuIcon />
          </IconButton>
        )}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: showBurger ? "flex-end" : "space-between",
            maxWidth: "90%",
            width: "90%",
          }}
        >
          <Box>
            <Tooltip title="Notifications">
              <IconButton sx={{ color: "white" }} onClick={handleOpenMenu}>
                <Badge
                  badgeContent={unreadNotif?unreadNotif:0}
                  color="error"
                  anchorOrigin={{
                    vertical: "top",
                    horizontal: "left",
                  }}
                >
                  <NotificationsActiveIcon sx={{ color: "white" }} />
                </Badge>
              </IconButton>
            </Tooltip>
            <Menu
              anchorEl={anchorEl}
              open={open}
              // onOpen={}
              onClose={handleCloseMenu}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "center",
              }}
              transformOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              sx={{
                "& .MuiList-root": {
                  maxWidth: "400px",
                  width: "100vmax",
                },
              }}
            >
              <List
                sx={{
                  maxWidth: 500,
                  width: "100%",
                  height: "400px",
                  overflowY: "scroll",
                }}
              >
                <ListItem>
                  <ListItemText primary="الإشعارات" />
                </ListItem>
                <Divider variant="middle" />
                {loading ? (
                  <CircularProgress sx={{color:'gray',margin:'auto'}}></CircularProgress>
                ) : notifictionsStore?.results?.length ? (
                  notifictionsStore?.results?.map((notification, index) => (
                    <NotificationItem
                      key={`notification ${index}`}
                      onClick={() => {
                        navigate(typesAndPaths[notification.types]);
                      
                        handleCloseMenu();
                      }}
                      content={notification?.message?notification?.message:notification.body}
                      time={`${ notification?.date?format(
                        notification?.date
                      ):""}`}
                      unread={index < unreadNotifCache.current}
                      natificationimage={notification?.image}
                    />
                    
                  ))
                ) : notifications.length>0?notifications.map((notification,index)=>(
                  <> <NotificationItem key={`notification ${index}`} onClick={()=>{
                     navigate(typesAndPaths[notification.types])
                     handleCloseMenu()
                   }}content={notification?.body}
                   time={notification?.title}
                   unread={index < unreadNotifCache.current}
                   
                   />
                   <Divider variant="middle" /></>
                  )):notifictionsStore?.results?.length>0?notifictionsStore?.results?.map((notification, index) => (
                    <NotificationItem
                      key={`notification ${index}`}
                      onClick={() => {
                        navigate(typesAndPaths[notification.types]);
                  
                        handleCloseMenu();
                      }}
                      content={notification?.message?notification?.message:notification.body}
                      time={`${format(
                        notification?.date ?? ""
                      )}`}
                      // natificationimage={notification?.image}
                      unread={index < unreadNotifCache.current}
                    />
                    
                  )):(
                   <MenuItem disabled>فارغ</MenuItem>
                 )}
              {/* */}
            
               {/* {notification.title&&<NotificationItem content={notification.body} time={notification.title} onClick={() => {
                        navigate(typesAndPaths[notification.types]);
                        handleCloseMenu();
                      }}/>} */}
                        <Divider variant="middle" />
               
                <ListItem>
                  <Button onClick={handleClear} color="error">
                    إزالة
                  </Button>
                </ListItem>
              </List>
            </Menu>
          </Box>
        </Box>
      </Toolbar>
      {resetNotificationsGetResponce.successAlert}
      {resetNotificationsGetResponce.failAlert}
    </AppBar>
  );
};

export default Topbar;

//----typechecking----

NotificationItem.propTypes = {
  onClick: PropTypes.func,
  content: PropTypes.string.isRequired,
  time: PropTypes.string.isRequired,
};

Topbar.propTypes = {
  showBurger: PropTypes.bool,
  onBurgerClick: PropTypes.func,
  notifications: PropTypes.arrayOf(PropTypes.object),
};
